import React from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import cx from "classnames";
import styles from "./styles.less";

const OptionsToContact = ({ phoneNumber, isMobileView, titleCall }) => {
  return (
    <div
      className={cx(styles.optionsWrapper, {
        [styles.mobileOptions]: isMobileView
      })}
    >
      <div className={styles.phoneOption}>
        <a href={`tel:${phoneNumber}`}>
          <Icon name="call" size="large" />
          {!isMobileView && phoneNumber}
          {isMobileView && titleCall}
        </a>
      </div>
      {/* <div className={styles.emailOption}>
        <a href={`mailto:${emailAddress}`}>
          <Icon name="mail" size="large" />
          {!isMobileView && emailAddress}
        </a>
      </div> */}
    </div>
  );
};

OptionsToContact.defaultProps = {
  isMobileView: false
};

OptionsToContact.propTypes = {
  isMobileView: PropTypes.bool,
  phoneNumber: PropTypes.string,
  titleCall: PropTypes.string
};

export default OptionsToContact;



// WEBPACK FOOTER //
// ./src/components/common/ContactUs/OptionsToContact/OptionsToContact.js